import { call, put, select } from 'redux-saga/effects';

import { createWorkflowDraft, deleteWorkflowDraft, getWorkflowByIdV2 } from 'api/WorkflowsAPI';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { BackendWorkflow } from 'modules/workflows/types';
import { WorkflowStatus } from '../../enums';
import { ResetWorkflowDraftRequestAction, actions } from '../actions';
import { WorkflowState } from '../ducks.types';
import { getWorkflowState } from '../selectors';
import { getParsedNodeData } from './sagaUtils';

function* deleteExistingDraft(draftId: number, errorMessage: string) {
  try {
    const { data } = yield call(deleteWorkflowDraft, draftId);
    if (data?.deleteWorkflowDraft?.status === WorkflowStatus.DELETED) {
      return !!data;
    } else {
      yield put(actions.resetWorkflowDraftError());
      yield put(addNegativeToastWithErrorId(errorMessage, 'deleteExistingDraft'));
    }
  } catch (error) {
    yield put(actions.resetWorkflowDraftError());
    yield put(addNegativeToastWithErrorId(errorMessage, 'deleteExistingDraft'));
  }
}

function* createNewDraftFromPublished(
  updatedWorkflow: BackendWorkflow,
  payload: ResetWorkflowDraftRequestAction['payload'],
  errorMessage: string,
) {
  const successMessage = 'Success! Draft reset to published.';
  try {
    const { data } = yield call(createWorkflowDraft, updatedWorkflow);
    if (data) {
      const { createWorkflowDraft: createWorkflowDraftResponse } = data;
      const { nodes = [] } = createWorkflowDraftResponse;
      yield put(actions.updateHasUnsavedChanges(false));
      yield put(actions.createWorkflowDraftResponse({ ...createWorkflowDraftResponse, nodes }));
      yield put(addPositiveToast(successMessage));
    }
  } catch (error) {
    const { workflowId, workflowType } = payload;
    yield put(actions.resetWorkflowDraftError());
    yield put(addNegativeToastWithErrorId(errorMessage, 'createNewDraftFromPublished'));
    yield put(actions.fetchWorkflowRequest(workflowId, workflowType, true));
  }
}

export default function* resetWorkflowDraftSaga(action: ResetWorkflowDraftRequestAction) {
  const errorMessage = 'Sorry, unable to reset draft to published.';
  const { workflowId, workflowType } = action.payload;

  try {
    const { data: publishedData } = yield call(getWorkflowByIdV2, workflowId, workflowType);
    if (publishedData?.workflow?.workflowReference) {
      const { workflow } = publishedData;
      const wfState: WorkflowState = yield select(getWorkflowState);
      const updatedWorkflow = getParsedNodeData(workflow, wfState);
      const deletedData: boolean = yield call(
        deleteExistingDraft,
        workflow?.workflowReference?.id,
        errorMessage,
      );
      if (deletedData) {
        yield call(
          createNewDraftFromPublished as any,
          updatedWorkflow,
          action.payload,
          errorMessage,
        );
      }
    }
  } catch (error) {
    yield put(actions.resetWorkflowDraftError());
    yield put(addNegativeToastWithErrorId(errorMessage, 'resetWorkflowDraftSaga'));
  }
}
